import React, { useEffect, useState } from 'react'
import { Modal } from "react-bootstrap";

import FormValidator from '../../../utils/FormValidator';
import { enumUtil } from '../../../utils/Enum';
import NotificationHandler from '../../../utils/NotificationHandler';
import { ServerRequestProtected } from '../../../utils/ServerDataRequest';
import AmountFormatter from '../../../utils/AmountFormatter';
import ModalHeader from '../../Setup/Shared/ModalHeader';
import { useSelector } from 'react-redux';
import handleNumericCheck from '../../../utils/HandleNumericKeys';

const MarkAsNoShowPopup = (props) => {

    const { isOpenPopup, ID, onClose, Status, handleSave, searchParam, setSearchParam } = { ...props }

    const Dropdowns = useSelector((state) => state?.GeneralDropDownsReducer);
    const NoShowSettings = Dropdowns?.NoShow;
    const NoShowAmntChrgd = NoShowSettings?.[0]?.NoShowAmountCharged || '0';
    const NoShowCalimCreation = NoShowSettings?.[0]?.NoShowClaimCreation;
    const CancelledSettings = Dropdowns?.Cancelled;
    const CancelledAmntChrgd = CancelledSettings?.[0]?.CancelledAmountCharged || '0';
    const CancelledCalimCreation = CancelledSettings?.[0]?.CancelledClaimCreation;

    let ClaimCreation = Status === "NoShow" ? NoShowCalimCreation : CancelledCalimCreation;
    const dynamicKey = `${Status}Amount`;
    const dynamicValue = Status === "NoShow" ? NoShowAmntChrgd : CancelledAmntChrgd;

    let NoShow_Modal = {
        [dynamicKey]: dynamicValue,
        AppointmentStatusID: '',
        Reason: "",
    }

    let validationModal = {
        AmountCharged: "",
        Reason: "",
    }

    let valModal = {}

    const [mainNoShowModal, setMainNoShowModal] = useState(NoShow_Modal);
    const [saveNoShowModal, setSaveNoShowModal] = useState({ 
        ...(ClaimCreation ? {[dynamicKey]: dynamicValue + ""} : {})
     });
    const [EditAmountCharged, setEditAmountCharged] = useState(false);
    const [NoShowValidationModal, setNoShowValidationModal] = useState(validationModal);

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        let propModal = { ...searchParam }
        let modal = { ...mainNoShowModal };
        let saveModal = { ...saveNoShowModal };
        modal[name] = value;
        propModal[name] = value;
        for (let property in NoShow_Modal) {
            if (property === name) {
                saveModal[name] = value + "";
            }
        }
        setSearchParam(propModal);
        setMainNoShowModal(modal);
        setSaveNoShowModal(saveModal);
    }

    const handleEditAmount = () => {
        setEditAmountCharged(!EditAmountCharged)
    }

    const formValidation = () => {

        let validationModal = {
            // AmountCharged: FormValidator(mainNoShowModal?.[dynamicKey], enumUtil.enumValidationType.Required, 'Amount Charged'),
            Reason: FormValidator(mainNoShowModal?.Reason, enumUtil.enumValidationType.Required, 'Reason'),
        }

        setNoShowValidationModal(validationModal);
        valModal = validationModal;
    }

    const handleOnSave = () => {
        formValidation();
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck);
        if (validation) {
            NotificationHandler('Fill all required fields', enumUtil.enumValidationType.error);
            return
        }

        let saveModal = {
            ...saveNoShowModal
        }

        handleSave(saveModal)
        // ServerRequestProtected(API_URL + '', 'post', saveModal)
        // .then((reponse)=>{

        // }).catch((error)=>{

        // })
    }

    const MarkAsCancelled = () => {
        return (
            <p className="heading">{`Mark As ${Status ?? 'Cancelled/No Show'} ?`}</p>
        )
    }

    useEffect(() => {
        // setSearchParam({ ...searchParam, [dynamicKey]: dynamicValue + "" })
        setMainNoShowModal({ ...mainNoShowModal, AppointmentStatusID: searchParam?.AppointmentStatusID })
        setSaveNoShowModal({ ...saveNoShowModal, AppointmentStatusID: searchParam?.AppointmentStatusID })
    }, [])

    return (
        <Modal show={isOpenPopup} onHide={isOpenPopup} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_export-excel_popup Mark-as-Cancelled "
        >
            <Modal.Body>
                <ModalHeader HeaderName={MarkAsCancelled} DeletePopup={''} isClosed={() => onClose(dynamicKey)} />
                {console.log("ClaimCreation", ClaimCreation, Status)}
                {ClaimCreation ? <div className='d-flex justify-content-between align-items-center paragraph px-2 py-1 mb-2'>
                    <div className='d-flex gap-1'>
                        <i className='icon-Vector13'></i>
                        <p className='text fs-11 fst-italic'>Patient will be charged <span className='heading fs-11'>{<AmountFormatter amount={mainNoShowModal?.[dynamicKey]} />}</span> {`for ${Status === "Cancelled" ? 'cancelling' : 'no show'}.`} </p>
                    </div>
                    {EditAmountCharged ? <i className='icon-Icon-metro-cross fs-10 ms-1' onClick={(e) => handleEditAmount(e)}></i>
                        : <i className='icon-Icon-material-edit fs-10' onClick={(e) => handleEditAmount(e)}></i>}
                </div> : <></>}

                {EditAmountCharged ?
                    <div className={`form-group input mb-2 ${NoShowValidationModal?.AmountCharged ? 'error' : ""}`}>
                        <label className='text fs-12 ar-light-color'>Amount Charged</label>
                        <input id={dynamicKey} name={dynamicKey} value={mainNoShowModal?.[dynamicKey]} onChange={(e) => handleOnChange(e)} onKeyPress={(event) => handleNumericCheck(event, 'decimal')} type="text" className='form-control fc-xs rounded-1'
                        />
                        {/* {NoShowValidationModal?.AmountCharged} */}
                    </div>

                    : <></>}

                <div className={`form-group input ${NoShowValidationModal?.Reason ? 'error' : ''}`}>
                    <label className="pb-3px">Reason<span className='req'>*</span></label>
                    <textarea id="Reason" name="Reason" value={mainNoShowModal?.Reason} onChange={(e) => handleOnChange(e)} rows="3" className="form-control"></textarea>
                    {NoShowValidationModal?.Reason}
                </div>
            </Modal.Body>
            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={() => onClose(dynamicKey)}>Cancel</button>
                <button className='btn btn-validate px-10 h-100' onClick={() => handleOnSave()}>Save</button>
            </div>
        </Modal>
    )
}

export default MarkAsNoShowPopup
